import enStrings from './en1'

export const defaultLocale = 'en'

const strings = {
    en: enStrings,
}

export default strings
